import get from "lodash/get";
import {
    putInvoiceClientItemLoading,
    putInvoiceClientItemReject,
    putInvoiceClientItemRequest,
    putInvoiceClientItemSuccess,
    putInvoiceClientItemReset,
} from "../../actions/invoiceClient/putItem";

export const putInvoiceClientItem = (body) => async (dispatch, getState) => {
    dispatch(putInvoiceClientItemLoading());
    try {
        const { data } = await putInvoiceClientItemRequest(body, getState);
        dispatch(putInvoiceClientItemSuccess(data));
    } catch (error) {
        dispatch(putInvoiceClientItemReject(get(error, "response.data", error)));
    } finally {
        setTimeout(() => { dispatch(putInvoiceClientItemReset()); }, 3000);
    }
    return Promise.resolve();
};
